<template>
  <div class="payment-panel-config">
    <div class="group-card">
      <h3 class="group-title">对照组</h3>
      <FormItem
        v-for="section in sections"
        :key="'control-' + section.key"
        :label="section.title + '：'"
        :label-width="150"
      >
        <div class="goods-section">
          <div
            class="section-header"
            @click="toggleControlSection(section.expandKey)"
          >
            <span class="section-title">{{ section.title }}</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180': isControlSectionExpanded(section.expandKey)
              }"
            />
          </div>
          <div
            v-show="isControlSectionExpanded(section.expandKey)"
            class="section-body"
          >
            <template v-if="controlDisabled">
              <div
                v-if="getReadonlyControlGoodsNames(section.key).length"
                class="readonly-goods-grid"
              >
                <div
                  v-for="(item, index) in getReadonlyControlGoodsNames(
                    section.key
                  )"
                  :key="'readonly-' + section.key + '-' + index"
                  class="readonly-goods-item"
                >
                  {{ item }}
                </div>
              </div>
              <div v-else class="readonly-empty-text">暂无默认模板</div>
            </template>
            <template v-else>
              <div class="goods-block">
                <div class="goods-block-title">会员付费项</div>
                <div class="goods-select-list">
                  <Select
                    v-for="slotIndex in vipSlots"
                    :key="'control-' + section.key + '-vip-' + slotIndex"
                    :disabled="disabled || controlDisabled"
                    clearable
                    :placeholder="'会员付费项' + (slotIndex + 1)"
                    :value="getControlGoodsId(section.key, slotIndex)"
                    @on-change="
                      handleControlGoodsChange(section.key, slotIndex, $event)
                    "
                  >
                    <Option
                      v-for="item in getGoodsOptions(section.optionKey, 'vip')"
                      :key="'control-' + section.key + '-vip-option-' + item.id"
                      :value="item.id"
                      :disabled="
                        isOptionDisabled(
                          getControlGoodsIds(section.key),
                          item.id,
                          slotIndex
                        )
                      "
                    >
                      {{ formatGoodsLabel(item) }}
                    </Option>
                  </Select>
                </div>
              </div>

              <div class="goods-block">
                <div class="goods-block-title">金币付费项</div>
                <div class="goods-grid">
                  <Select
                    v-for="slotIndex in goldSlots"
                    :key="'control-' + section.key + '-gold-' + slotIndex"
                    :disabled="disabled || controlDisabled"
                    clearable
                    :placeholder="'金币付费项' + (slotIndex - 2)"
                    :value="getControlGoodsId(section.key, slotIndex)"
                    @on-change="
                      handleControlGoodsChange(section.key, slotIndex, $event)
                    "
                  >
                    <Option
                      v-for="item in getGoodsOptions(section.optionKey, 'gold')"
                      :key="
                        'control-' + section.key + '-gold-option-' + item.id
                      "
                      :value="item.id"
                      :disabled="
                        isOptionDisabled(
                          getControlGoodsIds(section.key),
                          item.id,
                          slotIndex
                        )
                      "
                    >
                      {{ formatGoodsLabel(item) }}
                    </Option>
                  </Select>
                </div>
              </div>
            </template>
          </div>
        </div>
      </FormItem>
    </div>

    <div
      v-for="(group, groupIndex) in formData.groups"
      :key="groupIndex"
      class="group-card"
    >
      <h3 class="group-title">实验组 {{ groupIndex + 1 }}</h3>
      <FormItem
        v-for="section in sections"
        :key="section.key"
        :label="section.title + '：'"
        :label-width="150"
      >
        <div class="goods-section">
          <div
            class="section-header"
            @click="toggleGroupSection(groupIndex, section.expandKey)"
          >
            <span class="section-title">{{ section.title }}</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180': isGroupSectionExpanded(
                  groupIndex,
                  section.expandKey
                )
              }"
            />
          </div>
          <div
            v-show="isGroupSectionExpanded(groupIndex, section.expandKey)"
            class="section-body"
          >
            <div class="goods-block">
              <div class="goods-block-title">会员付费项</div>
              <div class="goods-select-list">
                <Select
                  v-for="slotIndex in vipSlots"
                  :key="section.key + '-vip-' + slotIndex"
                  :disabled="disabled"
                  clearable
                  :placeholder="'会员付费项' + (slotIndex + 1)"
                  :value="getGroupGoodsId(groupIndex, section.key, slotIndex)"
                  @on-change="
                    handleGoodsChange(
                      groupIndex,
                      section.key,
                      slotIndex,
                      $event
                    )
                  "
                >
                  <Option
                    v-for="item in getGoodsOptions(section.optionKey, 'vip')"
                    :key="section.key + '-vip-option-' + item.id"
                    :value="item.id"
                    :disabled="
                      isOptionDisabled(
                        getGroupGoodsIds(groupIndex, section.key),
                        item.id,
                        slotIndex
                      )
                    "
                  >
                    {{ formatGoodsLabel(item) }}
                  </Option>
                </Select>
              </div>
            </div>

            <div class="goods-block">
              <div class="goods-block-title">金币付费项</div>
              <div class="goods-grid">
                <Select
                  v-for="slotIndex in goldSlots"
                  :key="section.key + '-gold-' + slotIndex"
                  :disabled="disabled"
                  clearable
                  :placeholder="'金币付费项' + (slotIndex - 2)"
                  :value="getGroupGoodsId(groupIndex, section.key, slotIndex)"
                  @on-change="
                    handleGoodsChange(
                      groupIndex,
                      section.key,
                      slotIndex,
                      $event
                    )
                  "
                >
                  <Option
                    v-for="item in getGoodsOptions(section.optionKey, 'gold')"
                    :key="section.key + '-gold-option-' + item.id"
                    :value="item.id"
                    :disabled="
                      isOptionDisabled(
                        getGroupGoodsIds(groupIndex, section.key),
                        item.id,
                        slotIndex
                      )
                    "
                  >
                    {{ formatGoodsLabel(item) }}
                  </Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
      </FormItem>
    </div>
  </div>
</template>

<script>
import { getBatch, getGoodsList } from '@/api/goods'
import { normalizeGroupParamByCapability } from '../helpers'

const EMPTY_LOOKUP = {}

export default {
  name: 'PaymentPanelConfig',
  props: {
    formData: {
      type: Object,
      required: true
    },
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    controlDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sections: [
        {
          key: 'countryIosGoodsIds',
          title: 'iOS付费模板',
          expandKey: 'iosExpanded',
          optionKey: 'iosCountry'
        },
        {
          key: 'countryAndroidGoodsIds',
          title: 'Android付费模板',
          expandKey: 'androidExpanded',
          optionKey: 'androidCountry'
        },
        {
          key: 'defaultIosGoodsIds',
          title: 'iOS默认付费模板',
          expandKey: 'iosDefaultExpanded',
          optionKey: 'iosDefault'
        },
        {
          key: 'defaultAndroidGoodsIds',
          title: 'Android默认付费模板',
          expandKey: 'androidDefaultExpanded',
          optionKey: 'androidDefault'
        }
      ],
      vipSlots: [0, 1, 2],
      goldSlots: [3, 4, 5, 6, 7, 8],
      defaultGroup: normalizeGroupParamByCapability('5'),
      goodsOptions: {
        iosCountry: { vip: [], gold: [] },
        androidCountry: { vip: [], gold: [] },
        iosDefault: { vip: [], gold: [] },
        androidDefault: { vip: [], gold: [] }
      },
      controlGoodsLookup: EMPTY_LOOKUP
    }
  },
  computed: {
    crowdCountryCodeList() {
      const directCodes = Array.isArray(this.formData.crowdCountryCodes)
        ? this.formData.crowdCountryCodes.filter(Boolean)
        : []

      if (directCodes.length) {
        return Array.from(new Set(directCodes))
      }

      const selectedIds = Array.isArray(this.formData.crowdIds)
        ? this.formData.crowdIds.map((item) => String(item))
        : []
      const crowdOptions = Array.isArray(this.formData.crowdOptions)
        ? this.formData.crowdOptions
        : []

      return Array.from(
        new Set(
          crowdOptions
            .filter((item) => selectedIds.includes(String(item.id)))
            .reduce((acc, item) => {
              acc.push(...this.getCrowdItemCountryCodes(item))
              return acc
            }, [])
            .filter(Boolean)
        )
      )
    }
  },
  watch: {
    crowdCountryCodeList() {
      this.loadGoodsOptions()
    }
  },
  created() {
    this.loadGoodsOptions()
  },
  methods: {
    getCrowdItemCountryCodes(item) {
      if (!item || typeof item !== 'object') return []

      const countryList =
        item.countryCodes ||
        item.countrycodes ||
        item.countryCodeList ||
        item.countryCodelist ||
        []

      return Array.isArray(countryList) ? countryList : []
    },
    buildGoodsQueryParams(goodsType, goodsChannel, worldWide) {
      const params = {
        current: -1,
        size: -1,
        goodsType,
        goodsChannel,
        worldWide
      }

      if (!worldWide && this.crowdCountryCodeList.length) {
        params.countryCodeList = this.crowdCountryCodeList.join(',')
      }

      return params
    },
    normalizePaymentPanel(param) {
      return normalizeGroupParamByCapability('5', param)
    },
    getControlParam() {
      return this.formData.controlGroupParam
        ? this.formData.controlGroupParam
        : this.normalizePaymentPanel()
    },
    getControlGoodsIds(sectionKey) {
      const groupParam = this.getControlParam()
      return Array.isArray(groupParam[sectionKey]) ? groupParam[sectionKey] : []
    },
    getControlGoodsId(sectionKey, slotIndex) {
      return this.getControlGoodsIds(sectionKey)[slotIndex] || null
    },
    getReadonlyControlGoodsNames(sectionKey) {
      const ids = Array.isArray(this.defaultGroup[sectionKey])
        ? this.defaultGroup[sectionKey].filter(Boolean)
        : []

      return ids.map((id) => this.controlGoodsLookup[id] || id).filter(Boolean)
    },
    handleControlGoodsChange(sectionKey, slotIndex, value) {
      if (this.controlDisabled) return
      const normalized = this.normalizePaymentPanel(
        this.formData.controlGroupParam
      )
      const targetIds = [...normalized[sectionKey]]
      targetIds[slotIndex] = value || null
      this.$set(this.formData, 'controlGroupParam', normalized)
      this.$set(this.formData.controlGroupParam, sectionKey, targetIds)
    },
    async loadGoodsOptions() {
      const requests = [
        getGoodsList(this.buildGoodsQueryParams(1, 0, false)),
        getGoodsList(this.buildGoodsQueryParams(0, 0, false)),
        getGoodsList(this.buildGoodsQueryParams(1, 1, false)),
        getGoodsList(this.buildGoodsQueryParams(0, 1, false)),
        getGoodsList(this.buildGoodsQueryParams(1, 0, true)),
        getGoodsList(this.buildGoodsQueryParams(0, 0, true)),
        getGoodsList(this.buildGoodsQueryParams(1, 1, true)),
        getGoodsList(this.buildGoodsQueryParams(0, 1, true))
      ]

      try {
        const [
          iosCountryVip,
          iosCountryGold,
          androidCountryVip,
          androidCountryGold,
          iosDefaultVip,
          iosDefaultGold,
          androidDefaultVip,
          androidDefaultGold
        ] = await Promise.all(requests)

        this.goodsOptions = {
          iosCountry: {
            vip: iosCountryVip.data.records || [],
            gold: iosCountryGold.data.records || []
          },
          androidCountry: {
            vip: androidCountryVip.data.records || [],
            gold: androidCountryGold.data.records || []
          },
          iosDefault: {
            vip: iosDefaultVip.data.records || [],
            gold: iosDefaultGold.data.records || []
          },
          androidDefault: {
            vip: androidDefaultVip.data.records || [],
            gold: androidDefaultGold.data.records || []
          }
        }
      } catch (error) {
        this.$Message.error('获取付费模板列表失败')
      }
    },
    async applyDefaultGroup(defaultParam) {
      const normalized = this.normalizePaymentPanel(defaultParam)
      this.defaultGroup = normalized

      const ids = [
        ...(normalized.countryIosGoodsIds || []),
        ...(normalized.countryAndroidGoodsIds || []),
        ...(normalized.defaultIosGoodsIds || []),
        ...(normalized.defaultAndroidGoodsIds || [])
      ].filter(Boolean)

      if (!ids.length) {
        this.controlGoodsLookup = EMPTY_LOOKUP
        return
      }

      try {
        const { data } = await getBatch({
          ids: Array.from(new Set(ids)).join(',')
        })
        this.controlGoodsLookup = (data || []).reduce((acc, item) => {
          acc[item.id] = item.goodsName
          return acc
        }, {})
      } catch (error) {
        this.$Message.error('获取默认付费模板详情失败')
      }
    },
    getGroupParam(groupIndex) {
      const group =
        Array.isArray(this.formData.groups) && this.formData.groups[groupIndex]
          ? this.formData.groups[groupIndex]
          : null

      return group && group.experimentGroupParam
        ? group.experimentGroupParam
        : this.normalizePaymentPanel()
    },
    getGroupGoodsIds(groupIndex, sectionKey) {
      const groupParam = this.getGroupParam(groupIndex)
      return Array.isArray(groupParam[sectionKey]) ? groupParam[sectionKey] : []
    },
    getGroupGoodsId(groupIndex, sectionKey, slotIndex) {
      return this.getGroupGoodsIds(groupIndex, sectionKey)[slotIndex] || null
    },
    handleGoodsChange(groupIndex, sectionKey, slotIndex, value) {
      const group =
        Array.isArray(this.formData.groups) && this.formData.groups[groupIndex]
          ? this.formData.groups[groupIndex]
          : null
      if (!group || !group.experimentGroupParam) return

      const normalized = this.normalizePaymentPanel(group.experimentGroupParam)
      const targetIds = [...normalized[sectionKey]]
      targetIds[slotIndex] = value || null

      this.$set(group, 'experimentGroupParam', normalized)
      this.$set(group.experimentGroupParam, sectionKey, targetIds)
    },
    getGoodsOptions(optionKey, type) {
      return this.goodsOptions[optionKey] && this.goodsOptions[optionKey][type]
        ? this.goodsOptions[optionKey][type]
        : []
    },
    formatGoodsLabel(item) {
      const priceText =
        item.goodsNum !== undefined && item.goodsNum !== null
          ? `${item.goodsChannelName}-${item.goodsPrice}-${item.goodsNum}`
          : `${item.goodsChannelName}-${item.goodsPrice}`
      return `${priceText}(${item.goodsName})`
    },
    isOptionDisabled(selectedIds, id, slotIndex) {
      return selectedIds.some(
        (currentId, currentIndex) =>
          currentIndex !== slotIndex && currentId && currentId === id
      )
    },
    toggleControlSection(expandKey) {
      if (this.controlDisabled) {
        this.$set(this.defaultGroup, expandKey, !this.defaultGroup[expandKey])
        return
      }
      this.$set(
        this.formData.controlGroupParam,
        expandKey,
        !this.formData.controlGroupParam[expandKey]
      )
    },
    isControlSectionExpanded(expandKey) {
      if (this.controlDisabled) {
        return Boolean(this.defaultGroup && this.defaultGroup[expandKey])
      }
      return Boolean(
        this.formData.controlGroupParam &&
          this.formData.controlGroupParam[expandKey]
      )
    },
    toggleGroupSection(groupIndex, expandKey) {
      const group = this.formData.groups[groupIndex]
      if (!group || !group.experimentGroupParam) return
      this.$set(
        group.experimentGroupParam,
        expandKey,
        !group.experimentGroupParam[expandKey]
      )
    },
    isGroupSectionExpanded(groupIndex, expandKey) {
      const group = this.formData.groups[groupIndex]
      return Boolean(
        group &&
          group.experimentGroupParam &&
          group.experimentGroupParam[expandKey]
      )
    },
    validate() {
      return true
    }
  }
}
</script>

<style scoped lang="less">
.payment-panel-config {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin: 20px 0;
}

.group-card {
  flex: 0 1 45%;
  box-sizing: border-box;
  border: 1px solid #e8eaec;
  padding: 20px;
  border-radius: 4px;
}

.group-title {
  margin-bottom: 20px;
}

.goods-section {
  border: 1px solid #e8eaec;
  border-radius: 4px;
}

.goods-section + .goods-section {
  margin-top: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  cursor: pointer;
  background: #f8f8f9;
}

.section-title {
  font-weight: 600;
}

.section-body {
  padding: 14px;
}

.goods-block + .goods-block {
  margin-top: 18px;
}

.goods-block-title {
  margin-bottom: 10px;
  font-weight: 600;
}

.goods-select-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.goods-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.readonly-goods-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.readonly-goods-item {
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 10px 12px;
  background: #fff;
  color: #515a6e;
}

.readonly-empty-text {
  color: #999;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
